export const ONE_TRUST_CONSENT_COUNTRIES = ["DE", "BE", "FR", "PL", "NL", "CZ", "SK", "ES"];

export const CONSENT_ONE_TRUST_GROUP_MAPPING = {
  C0001: "necessary",
  C0002: "preferences",
  C0003: "statistics",
  C0004: "marketing",
};

export const HISTORY_DB_KEY = "recommendationsHistoryDb";

export enum TrackingEventType {
  PageLoad = "PageLoad",
  EnterViewport = "EnterViewport",
  Click = "Click",
  SponsoredRecommendationLoad = "SponsoredRecommendationLoad",
}

export const EMAIL_REGEX = /[^\s@]+@[^\s@]+\.\p{L}{2,}/u;
